import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMyRegion } from "../../../../redux/actions/userActions";
import {
  setActiveProfession,
  setActiveVacancy,
} from "../../../../redux/actions/searchProfessionActions";
import cn from "classnames";

import variableLanguage from "../../../utils/hooks/hookGetVariablesLanguage";
import { Select, Spin } from "antd";
import SkillBlockProfession from "../ReuseComponents/SkillBlockProfession";
import SkillBlockVacancy from "../ReuseComponents/SkillBlockVacancy";
import ParentBlockProgressVertical from "../Chart/ParentBlockProgressVertical";
import cities from "../../../data/hhcities.json";
import citiesRus from "../../../data/citiesRussua.json";
import { defaultFuncAndData } from "../../../utils/defaultData";
import Button from "../../../components/Button/Button";

import { ReactComponent as InfoIconB } from "../../../../images/search_profession/info_icon_b.svg";
import { ReactComponent as StarIconB } from "../../../../images/search_profession/star_icon_b.svg";
import { ReactComponent as Star } from "../../../../images/search_profession/nav_bar-star.svg";
import vacancies from "../../../../images/search_profession/vacancies_filter.svg";
import filter from "../../../../images/search_profession/filter_icon.svg";
import favorite from "../../../../images/search_profession/favorite_icon.svg";
import hh_icon from "../../../../images/search_profession/hh_icon.svg";
import trud_vsem_icon from "../../../../images/search_profession/trud_vsem-icon.svg";
import language_icon from "../../../../images/search_profession/language_icon.svg";
import CardVacancySection from "./CardVacancy/CardVacancySection";

const VacancySection = (props) => {
  const {
    setFlagModalFilter,
    setFlagModalFavorite,
    flagModalFavorite,
    handleChangeFavoriteProfession,
    favoriteProfession,
    favoriteVacancy,
    heightTraektory,
    setFlagModalProfessionInfo,
    handleAddSkillTraektory,
    myAnimationHidden,
    myAnimationFlagMove,
    setCoordsTagAnimation,
    currentSkillAddTraektory,
    vacancycData,
    flagLoadingVacancy,
    handleChangeFavoriteVacancy,
    flagSteps,
    currentStep,
  } = props;
  const dispatch = useDispatch();
  const variables_4 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_4",
  });
  const variables_5 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_5",
  });
  const variables_11 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_11",
  });
  const variables_12 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_12",
  });
  const variables_13 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_13",
  });
  const variables_18 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_18",
  });
  const variables_21 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_21",
  });
  const variables_22 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_22",
  });
  const variables_33 = variableLanguage({
    keyPage: "searchProfession",
    keyVariable: "variables_33",
  });

  const { activeProfession, activeVacancy } = useSelector(
    (state) => state.SearchProfession
  );
  const { userSkills } = useSelector((state) => state.Reducer);
  const [allCities, setAllCities] = useState([]);
  const [scrollYVacancy, setScrollYVacancy] = useState(0);
  const [flagOpenCity, setFlagOpenCity] = useState(false);
  const [nameRegion, setNameRegion] = useState("");

  const vanaciesRef = useRef();
  const listVacancyRef = useRef();

  let getCities = () => {
    let result = [];
    const arrCities = citiesRus.areas;
    for (let i = 0; i < arrCities.length; i++) {
      result.push(arrCities[i].name);
    }
    const relustObjCity = arrCities.map((city) => {
      return {
        name: city.name,
        id: city.region,
        areas: city.areas,
      };
    });
    setAllCities(relustObjCity);
  };
  let changeRegion = (value) => {
    const selectedCity = JSON.parse(value);
    const newObj = {
      name: nameRegion,
      id: selectedCity.id,
      areas: selectedCity.areas,
    };
    localStorage.setItem("region_new", value);
    dispatch(setMyRegion(newObj));
    setNameRegion("");
  };
  let handleScroll = (event) => {
    if (event.currentTarget.scrollTop < 110) {
      setScrollYVacancy(0);
      if (vanaciesRef?.current && scrollYVacancy) {
        vanaciesRef.current.scroll({
          top: 0,
          behavior: "smooth",
        });
      }
    } else setScrollYVacancy(1);
  };
  let minHeightList = () => {
    // функция высчитывает высоту для списка вакансий (ul), что-бы всегда был скролл.
    let height = window.innerHeight - heightTraektory - 40;
    return height;
  };
  let calcActiveFavorite = () => {
    if (
      favoriteProfession &&
      favoriteProfession.length > 0 &&
      activeProfession !== null
    ) {
      for (let i = 0; i < favoriteProfession.length; i++) {
        if (activeProfession.id === favoriteProfession[i].profession.id)
          return true;
      }
    }
    return false;
  };

  useEffect(() => {
    return () => {
      dispatch(setActiveVacancy(null));
      dispatch(setActiveProfession(null));
    };
  }, []);
  console.log("activeVacancy", activeVacancy);
  return (
    <>
      <div
        className={
          scrollYVacancy > 0
            ? "vacancies_title-row hide"
            : "vacancies_title-row"
        }
      >
        <div
          className={
            scrollYVacancy > 0 ? "vacancies_title active" : "vacancies_title"
          }
        >
          {activeProfession !== null || activeVacancy ? (
            <div className={"vacancies_title-text"}>
              <img src={vacancies} />
              <span>{variables_12}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className={scrollYVacancy > 0 ? "filters hide" : "filters"}>
          <div
            onClick={() => {
              if (activeProfession) setFlagModalFilter(true);
            }}
            className={activeProfession ? "filter" : "filter disabled"}
          >
            <div className="svg">
              <img src={filter} />
            </div>
            <span>{variables_4}</span>
          </div>
          <div
            className="favorites"
            onClick={() => setFlagModalFavorite(!flagModalFavorite)}
          >
            <div className="svg">
              <img src={favorite} />
            </div>
            <span>
              {variables_5}({favoriteVacancy.length + favoriteProfession.length}
              )
            </span>
          </div>
          <div className="select_language">
            <div className="img">
              <img src={language_icon} alt="language_icon" />
            </div>
            <Select
              className={flagOpenCity ? "regionSelect active" : "regionSelect"}
              size="medium"
              showSearch
              showArrow={false}
              placeholder={variables_33}
              onChange={changeRegion}
              onSearch={(value) => setNameRegion(value)}
              defaultValue={
                localStorage.getItem("region_new")
                  ? JSON.parse(localStorage.getItem("region_new")).name
                  : ""
              }
              onDropdownVisibleChange={(e) => {
                setFlagOpenCity(e);
                if (e && allCities.length === 0) getCities();
              }}
              dropdownAlign={{
                offset: [0, 0],
              }}
              filterOption={(inputValue, option) => {
                const city = JSON.parse(option.value);
                const searchTerm = inputValue.toLowerCase();

                // Проверяем совпадение с названием города
                if (city.name.toLowerCase().includes(searchTerm)) return true;

                // Проверяем совпадение с ID города
                if (city.id.toString().includes(inputValue)) return true;

                // Проверяем совпадение с названиями областей
                return city.areas.some((area) =>
                  area.name.toLowerCase().includes(searchTerm)
                );
              }}
            >
              <>
                {allCities.length > 0 &&
                  allCities.map((city, indx) => (
                    <Select.Option key={indx} value={JSON.stringify(city)}>
                      {`${nameRegion} ${nameRegion !== "" ? "/" : " "}${
                        city.name
                      }`}
                    </Select.Option>
                  ))}
              </>
            </Select>
          </div>
        </div>
      </div>
      <p>
        {variables_21} {activeProfession && activeProfession.professionTitle}
      </p>
      <ParentBlockProgressVertical
        allJobs={vacancycData}
        setActiveVacancy={(elem) => dispatch(setActiveVacancy(elem))}
        activeVacancy={activeVacancy}
      />
      {/* <Button
        text={variables_22}
        click={() => window.open(activeVacancy?.alternate_url, "blank")}
        margin={"70px 0 0 0"}
        padding={"6px 10px 8px"}
        zIndex={3}
      /> */}
      {/* <div
        className="btn_go"
        onClick={() => window.open(activeVacancy?.alternate_url, "blank")}
      >
        {variables_22}
      </div> */}
      <div
        onScroll={handleScroll}
        style={
          scrollYVacancy > 0
            ? { maxHeight: window.innerHeight - 60 - heightTraektory }
            : { maxHeight: window.innerHeight - 95 - heightTraektory }
        }
        className={cn("vacancies_block", {
          active: scrollYVacancy > 1,
          opacity: flagSteps && currentStep !== 1,
        })}
        ref={vanaciesRef}
      >
        <ul
          style={
            scrollYVacancy > 0
              ? { minHeight: minHeightList() || "inherit" }
              : {}
          }
          ref={listVacancyRef}
        >
          {vacancycData &&
            vacancycData.length > 0 &&
            vacancycData.map((elem, indx) => (
              <React.Fragment key={indx}>
                <CardVacancySection
                  vacancy={elem}
                  userSkills={userSkills}
                  handleAddSkillTraektory={handleAddSkillTraektory}
                  setCoordsTagAnimation={setCoordsTagAnimation}
                  handleChangeFavoriteVacancy={handleChangeFavoriteVacancy}
                  favoriteVacancy={favoriteVacancy}
                />
              </React.Fragment>
            ))}
        </ul>
        {flagLoadingVacancy ? (
          <Spin
            style={{
              position: "absolute",
              left: "50%",
              top: 240,
              transform: "translate(-50%, 0)",
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default VacancySection;
